import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { ArrowRight, MonitorDown } from 'lucide-react'
import { buttonVariants } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { useGameVersion } from 'app/frontend/base/hooks/useGameVersion'
import Callout from './Callout'

const DesktopCallout = () => {
  const { t } = useTranslation()
  const gameVersion = useGameVersion()

  return (
    <Callout
      icon={MonitorDown}
      title={t('homepage.desktop-title')}
      description={t(
        gameVersion.has('blizzard_api')
          ? 'homepage.desktop-description'
          : 'homepage.desktop-description-companion',
      )}
    >
      <Link
        to='/desktop'
        className={cn(buttonVariants({ variant: 'outline' }), 'gap-2')}
      >
        {t('homepage.desktop-link')}
        <ArrowRight className='h-4 w-4' />
      </Link>
    </Callout>
  )
}

export default DesktopCallout
